export default __webpack_public_path__ + "static/media/book_man.53cc5557.png";